import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api } from '../../../../api';
import {
    Button,
    Input,
    Container,
    Row,
    Col,
    FormGroup,
} from "reactstrap";
import Cookies from 'js-cookie';

const EditVendorStock = () => {
    const { id } = useParams();
    const [updateValue, setupdateValues] = useState({
        vendor_product_id: id, // changed from product_id
        product_name: '',
        available_stock: '',
        total_stock: '',
        cost: ''
    });

    useEffect(() => {
        // Use vendor_product_id in the GET request
        const company_id = Cookies.get('company_id');
        api.get(`viewItemsVM.php?vendor_product_id=${id}&company_id=${company_id}`)
            .then((res) => {
                if (res.data.status === 'success' && res.data.product) {
                    const product = res.data.product;
                    setupdateValues(prevState => ({
                        ...prevState,
                        vendor_product_id: product.vendor_product_id,
                        product_name: product.product_name,
                        available_stock: product.available_stock,
                        total_stock: product.total_stock,
                        cost: product.cost,
                    }));
                } else {
                    console.error("Product not found or error:", res.data.message);
                }
            })
            .catch((err) => console.error("Error fetching product:", err));
    }, [id]);

    const handleSubmit = async (event) => {
        event.preventDefault();
    
        try {
            // Send vendor_product_id and other fields
            const company_id = Cookies.get('company_id');
            const response = await api.put(`viewItemsVM.php?company_id=${company_id}`, {
                vendor_product_id: id,
                product_name: updateValue.product_name,
                available_stock: updateValue.available_stock,
                total_stock: updateValue.total_stock,
                cost: updateValue.cost,
                company_id: company_id // <-- added to body
            });
    
            if (response.data.status === 'success') {
                alert("Product updated successfully!");
                window.history.back();
            } else {
                alert(response.data.message || "Update failed");
            }
        } catch (error) {
            console.error("Error updating product:", error);
            alert("Failed to update product");
        }
    };
    

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setupdateValues((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    console.log('update',updateValue);

    return (
        <>
            <div className="header bg-gradient-info py-7 py-lg-8">
                <Col className="order-xl-2 mb-5 mb-xl-0 text-center">
                    <h1>Edit Vendor Stock Details</h1>
                </Col>
                <Link to="/store-admin/store-management/Vendormanagement"> <Button className='ml-5' style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }}>Back</Button></Link>
                <Container className="py-4 ">
                    <div className="p-4 rounded" style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px' }}>
                        <Row className='px-3'>
                            <Col md={12}>
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="input-status">Item Name</label>
                                    <Input
                                        className="form-control-alternative"
                                        id="input-name"
                                        type="text"
                                        name="product_name"
                                        onChange={handleInputChange}
                                        value={updateValue.product_name}
                                    />
                                </FormGroup>
                            </Col>
                            
                            <Col md={12}>
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="input-manager">Current Stock</label>
                                    <Input
                                        className="form-control-alternative"
                                        id="input-manager"
                                        type="number"
                                        name='available_stock'
                                        onChange={handleInputChange}
                                        value={updateValue.available_stock}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="input-starting">Total Stock</label>
                                    <Input
                                        className="form-control-alternative"
                                        id="input-starting"
                                        type="text"
                                        name="total_stock"
                                        onChange={handleInputChange}
                                        value={updateValue.total_stock}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="input-ending">Cost</label>
                                    <Input
                                        className="form-control-alternative"
                                        id="input-ending"
                                        type="number"
                                        name="cost"
                                        onChange={handleInputChange}
                                        value={updateValue.cost}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg='12' className='text-center mb-2'>
                                <Button style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }} type="submit" onClick={handleSubmit}>Submit</Button>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </>
    );
};

export default EditVendorStock;
